import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./Breadcrumb";
import styles from "./PageBreadcrumb.module.css";
import { NAV_ITEMS } from "../helpers/navCatalog.generated";
import { breadcrumbTrail, rubriqueForPath } from "../nav/navCatalogHelpers";

export interface BreadcrumbEntry {
  label: string;
  href: string;
}

interface PageBreadcrumbProps {
  items?: BreadcrumbEntry[];
  current: string;
  currentPath: string;
}

export const PageBreadcrumb: React.FC<PageBreadcrumbProps> = ({
  items = [],
  current,
  currentPath,
}) => {
  // Fil commun (Breadcrumb::trail) : Accueil, rubrique, page. Des `items` explicites
  // remplacent la rubrique déduite (pages de l'application hors catalogue).
  const auto = breadcrumbTrail(currentPath, current);
  const trail = items.length > 0
    ? [{ name: "Accueil", path: "/" }, ...items.map((i) => ({ name: i.label, path: i.href })), { name: current, path: currentPath }]
    : auto;
  const ancestors = trail.slice(0, -1);
  const page = trail[trail.length - 1];
  const schemaItems = trail.map((step, index) => ({
    "@type": "ListItem" as const,
    position: index + 1,
    name: step.name,
    item: `https://kenometric.fr${step.path}`,
  }));
  // Page serveur (Twig ou prérendue) : vrai rechargement plutôt que navigation React.
  const isServerPage = (path: string) => path === "/" || NAV_ITEMS.find((i) => i.path === path)?.isStatic === true;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: schemaItems,
          })}
        </script>
      </Helmet>

      {/* Même balisage que le fil des pages serveur (.km-crumb de mag-header.css) : même aspect partout. */}
      <nav className="km-crumb" aria-label="Fil d'Ariane" data-nav-emplacement="fil_ariane">
        <ol>
          {ancestors.map((step) => (
            <li key={step.path}>
              {isServerPage(step.path)
                ? <a href={step.path} data-nav-rubrique={rubriqueForPath(step.path) ?? "aucune"}>{step.name}</a>
                : <Link to={step.path} data-nav-rubrique={rubriqueForPath(step.path) ?? "aucune"}>{step.name}</Link>}
            </li>
          ))}
          <li><span aria-current="page">{page.name}</span></li>
        </ol>
      </nav>
    </>
  );
};
